import { icons } from "@shinetools/sunshine-icons";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
const Icon = forwardRef(({
  className,
  color,
  icon,
  style
}, ref) => /* @__PURE__ */jsx("svg", {
  className,
  fill: color || "currentColor",
  ref,
  style,
  viewBox: "0 0 24 24",
  children: icons[icon].map(({
    component: Component,
    props: parsedProps
  }, i) => /* @__PURE__ */jsx(Component, {
    ...parsedProps
  }, `component-${i}`))
}));
Icon.displayName = "Icon";
export { Icon };
//# sourceMappingURL=Icon.InternalIcon.mjs.map
